"use strict";

function NotificationTrayModal() {
  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.extends = [_TrayModal];

  this.init = function () {
    this._super();
    this.showCloseButton = false;
  };

  this.initAllReady = function () {
    this._super();
  };

  this.destroy = function () {};
}